import { ClaimCreatorProfile } from '@/components/talent/ClaimCreatorProfile';

const ClaimCreatorProfilePage = () => {
  return <ClaimCreatorProfile />;
};

export default ClaimCreatorProfilePage;
